export const OAUTH_RESPONSE_TYPE: string = 'code'
export const OAUTH_WINDOW_SIZING: string = 'width=700,height=800'

export const INTERVAL_PERIOD: number = 750

/**
 * Hosts whose OAuth login page sends an enforced `Cross-Origin-Opener-Policy`, which makes the opener
 * read its popup as closed while the user is still logging in (APD-14151). Zendesk serves its
 * authorisation endpoint from `{SubDomain}.zendesk.com`.
 */
export const COOP_ENFORCING_AUTH_HOST_SUFFIXES: readonly string[] = ['.zendesk.com']
